module.exports = __webpack_public_path__ + "assets/images/deviceExport-27f860117e4ec8985086aa6c5c05ac77.png";